import {
  FETCH_AUTH_EMAIL,
  FETCH_INITIAL_DATA,
  FETCH_LOGGED_IN_USER,
  FETCH_REMOTE_CONFIG,
  FETCH_TESTING_OPTIONS,
} from '/enum/launchSequence.enum';

export default (state = {}) => {
  return {
    ...state,
    completedSteps: {
      [FETCH_LOGGED_IN_USER]: false,
      [FETCH_INITIAL_DATA]: false,
      [FETCH_AUTH_EMAIL]: false,
      [FETCH_TESTING_OPTIONS]: false,
      [FETCH_REMOTE_CONFIG]: false,
    },
  };
};
